import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay", "toggleButton"]

  connect() {
    this.hide()
    this.setupEventListeners()
  }

  disconnect() {
    this.removeEventListeners()
  }

  setupEventListeners() {
    this.handleResize = this.handleResize.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    window.addEventListener("resize", this.handleResize)
    document.addEventListener("click", this.handleClickOutside)
  }

  removeEventListeners() {
    window.removeEventListener("resize", this.handleResize)
    document.removeEventListener("click", this.handleClickOutside)
  }

  handleResize() {
    if (window.innerWidth >= 1024) {
      this.show()
      this.hideOverlay()
    } else {
      this.hide()
    }
  }

  handleClickOutside(event) {
    if (window.innerWidth >= 1024) return
    
    if (this.hasSidebarTarget && 
        !this.sidebarTarget.contains(event.target) && 
        !this.toggleButtonTarget.contains(event.target) &&
        this.isVisible()) {
      this.hide()
    }
  }

  toggle() {
    if (this.isVisible()) {
      this.hide()
    } else {
      this.show()
    }
  }

  show() {
    if (this.hasSidebarTarget) {
      this.sidebarTarget.classList.remove("-translate-x-full")
      
      if (window.innerWidth < 1024) {
        this.showOverlay()
      }
    }
  }

  hide() {
    if (this.hasSidebarTarget) {
      if (window.innerWidth < 1024) {
        this.sidebarTarget.classList.add("-translate-x-full")
        this.hideOverlay()
      }
    }
  }

  showOverlay() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden")
    }
  }

  hideOverlay() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("hidden")
    }
  }

  isVisible() {
    return this.hasSidebarTarget && !this.sidebarTarget.classList.contains("-translate-x-full")
  }
}
